import { useTranslation } from "react-i18next";
import { TbStethoscope, TbUserQuestion } from "react-icons/tb";
import { invoiceOwnerLabel } from "src/helpers/invoiceOwner";
import type { Invoice } from "src/types";
import "./invoiceOwnerChip.scss";

interface InvoiceOwnerChipProps {
    invoice: Pick<Invoice, "ownerDoctorId" | "ownerDoctorName">;
}

/** Which doctor an invoice belongs to — only rendered where the viewer sees several doctors' invoices. */
export default function InvoiceOwnerChip({ invoice }: InvoiceOwnerChipProps) {
    const { t } = useTranslation();
    const isSystem = invoice.ownerDoctorId === "system";
    const label = invoiceOwnerLabel(invoice, t);
    return (
        <span
            className={`invoice-owner-chip${isSystem ? " invoice-owner-chip--system" : ""}`}
            title={t("invoices.ownerTitle", { name: label })}
        >
            {isSystem ? <TbUserQuestion aria-hidden /> : <TbStethoscope aria-hidden />}
            {label}
        </span>
    );
}
